import React, { useEffect } from 'react';

interface PolicyModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  content: string;
}

const PolicyModal: React.FC<PolicyModalProps> = ({ isOpen, onClose, title, content }) => {
  useEffect(() => {
    if (!isOpen) return;
    const handleEsc = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };
    window.addEventListener('keydown', handleEsc);
    return () => {
      window.removeEventListener('keydown', handleEsc);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex justify-center items-center z-50 p-4" onClick={onClose}>
      <div className="bg-slate-200 text-slate-800 rounded-lg shadow-xl w-full max-w-2xl max-h-[80vh] flex flex-col" onClick={(e) => e.stopPropagation()}>
        <header className="p-4 border-b border-slate-300 flex justify-between items-center flex-shrink-0">
          <h2 className="text-lg font-bold">{title}</h2>
          <button onClick={onClose} className="text-slate-500 hover:text-slate-800 text-3xl">&times;</button>
        </header>
        <div className="p-6 flex-grow overflow-y-auto">
          <pre className="whitespace-pre-wrap text-sm leading-relaxed font-sans">{content}</pre>
        </div>
        <footer className="p-4 border-t border-slate-300 flex justify-end flex-shrink-0">
          <button onClick={onClose} className="bg-rose-600 hover:bg-rose-700 text-white font-bold py-2 px-4 rounded-lg">
            닫기
          </button>
        </footer>
      </div>
    </div>
  );
};

export default PolicyModal;